export class IFilterApiModel {
  refName?: string;

  allergen?: number[];
  productGroup?: number[];
  tag?: number[];
  hasMotive?: boolean;
  postNumber?: string;
  categoryId?: number;
  companyId?: number;

  // For express flow compatibility
  categoryNameId?: string;
}
